import cx from 'classnames';
import PropTypes from 'prop-types';

import useStyles from './useStyles';

export const DotsLoader = ({ className }) => {
  const styles = useStyles();
  return (
    <div className={cx(styles.root, className)}>
      <div />
      <div />
      <div />
    </div>
  );
};

DotsLoader.propTypes = {
  className: PropTypes.string,
};

DotsLoader.defaultProps = {
  className: '',
};
